import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Inputbox from "../Component/Inputbox";
import { BiChevronLeft } from "react-icons/bi";
import Button from "../Component/Button";
import REACT_APP_API_URL from "../utils/constant";
import { showToast } from "../helper/Toster";
import Logo from "../assets/Image/logo.png";

const ForgetPassword = () => {
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [error, setError] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(false);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    let valid = true;
    if (email.trim() === "") {
      setError("Please enter your email");
      valid = false;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const isValidate = emailRegex.test(email);
      if (!isValidate) {
        setError("Please enter a valid email");
        valid = false;
      }
    }

    if (!valid) {
      return;
    }

    try {
      let result = await fetch(`${REACT_APP_API_URL}admin-forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
        }),
      });
      result = await result.json();
      console.log(result);
      if (result && result.success === "true") {
        showToast("success", "Email sent successfully for reset your password");
        setEmail("");
      }
      if (result && result.success === "false") {
        showToast("error", "Please enter correct email");
      }
    } catch (err) {
      console.log(err);
      alert("Something went wrong while sending a link to email");
    }
  };

  return (
    <div className="position-relative">
      {loading && (
        <div id="loader_class" className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}
      <div className="container-xxl">
        <div className="authentication-wrapper authentication-basic container-p-y">
          <div className="authentication-inner">
            <div className="card px-sm-6 px-0">
              <div className="card-body">
                <div className="mb-4 text-center">
                  <img src={Logo} alt="" height={120} />
                </div>
                <h4 className="mb-1 text-start">Forgot Password? 🔒</h4>
                <p className="mb-6">
                  Enter your email and we'll send you instructions to reset your
                  password
                </p>

                <form
                  id="formAuthentication"
                  className="mb-6"
                  action="/newpassword"
                  method=""
                >
                  <div className="mb-6">
                    <label htmlFor="email" className="form-label fw-semibold">
                      Email
                    </label>
                    <Inputbox
                      type="email"
                      placeholder="Enter your email address"
                      className="form-control"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    {error && <div className="text-danger mt-1">{error}</div>}
                  </div>

                  <div className="">
                    <Button
                      className=" w-100"
                      type="submit"
                      onClick={handleSubmit}
                    >
                      Send Reset Link
                    </Button>
                  </div>
                </form>

                <div className="text-center">
                  <NavLink
                    to="/login"
                    className="d-flex justify-content-center"
                  >
                    <BiChevronLeft className="fs-4" />
                    Back to login
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
